export default "/assets/images/overreactor2.png?41fa2a968f3a460a6c33e81e75738880";